'use client';
import AppDrawer from '@/containers/AppDrawer/AppDrawer';
import useUser from '@/shared/hooks/useUser';
import { ReactNode } from 'react';

interface PageWithDrawerProps {
  children?: ReactNode;
}
const PageWithDrawer = ({ children }: PageWithDrawerProps) => {
  const { isLoggedIn } = useUser();

  return isLoggedIn ? (
    <div className="drawer drawer-open">
      <input id="my-drawer-2" type="checkbox" className="drawer-toggle" />
      {/* overflow-hidden */}
      <div className="drawer-content bg-base-100 relative flex-1 rounded-s-2xl shadow-md">
        {children}
      </div>
      <div className="drawer-side !flex flex-1 flex-col px-3 lg:w-[292px] lg:max-w-[292px] lg:min-w-[292px]">
        <label
          htmlFor="my-drawer-2"
          aria-label="close sidebar"
          className="drawer-overlay"></label>
        <AppDrawer />
      </div>
    </div>
  ) : (
    children
  );
};

export default PageWithDrawer;
